// @flow
import CONST from 'app/common/lib/Const';

/**
 * multipleAccountStorage utils
 * provides interface for storing, retrieving and interacting
 * with account switcher storage
 *
 * This allows us to make changes only to storage logic in this file
 * without changing the Account Switcher logic
 *
 * TODO(rmist): Replace groupId with sessionID once we persist it
 */

/**
 * Currently relies on window.localStorage
 * if we change storage methods, change the below setters/getters
 */

const getItem = (key) => (typeof window !== 'undefined' ? window.localStorage.getItem(key) : null);

const setItem = (key, value) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, value);
  }
};

/**
 * End of storage implementation
 */

const multipleAccountStorage: Object = {};

/**
 * Gets non-formatted storage items
 *
 * @return {String}
 */
multipleAccountStorage.getAccounts = () => getItem(CONST.MULTIPLE_ACCOUNTS);

/**
 * Get JSON formatted account storage items
 *
 * @return {JSON}
 */
multipleAccountStorage.getAccountsJSON = () =>
  multipleAccountStorage.getAccounts() ? JSON.parse(multipleAccountStorage.getAccounts()) : {};

/**
 * Get formatted account group id
 *
 * @return {String}
 */
multipleAccountStorage.getGroupId = () => {
  const groupId = getItem(CONST.MULTIPLE_ACCOUNTS_GROUP);
  return groupId ? JSON.parse(groupId) : null;
};

/**
 * Set the account storage items
 *
 * @arg {String}: string to set as account storage item
 */
multipleAccountStorage.setAccounts = (item: String) => setItem(CONST.MULTIPLE_ACCOUNTS, item);

/**
 * Set the group id
 *
 * @arg {String}: string to set as group id
 */
multipleAccountStorage.setGroupId = (id: String) =>
  setItem(CONST.MULTIPLE_ACCOUNTS_GROUP, JSON.stringify(id));

export default multipleAccountStorage;
